module.exports = __webpack_public_path__ + "img/classroom.c9a01dbf.svg";